import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function PWAInstall() {
  const [prompt, setPrompt] = useState(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setPrompt(e); setShown(true); };
    window.addEventListener("beforeinstallprompt", handler);
    // If already installed, don't show
    if (window.matchMedia("(display-mode: standalone)").matches) setShown(false);
    if (localStorage.getItem("jays_pwa_dismissed") === "1") setShown(false);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    await prompt.prompt();
    setShown(false);
    localStorage.setItem("jays_pwa_dismissed", "1");
  };

  const dismiss = () => { setShown(false); localStorage.setItem("jays_pwa_dismissed", "1"); };

  if (!shown || !prompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-50" data-testid="pwa-install-banner">
      <div className="bg-white border-2 border-[#0F766E] rounded-2xl p-4 shadow-2xl flex items-center gap-3">
        <img src="/logo.png" alt="" className="h-14 w-14 object-contain" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold text-[#1C1917] leading-tight">Install Jay's Vet</div>
          <p className="text-xs text-[#57534E] mt-0.5">Add to your home screen for one-tap access.</p>
        </div>
        <button onClick={install} className="btn-primary px-4 py-2 rounded-full text-xs font-semibold inline-flex items-center gap-1" data-testid="pwa-install-btn">
          <Download size={14} /> Install
        </button>
        <button onClick={dismiss} aria-label="Dismiss" data-testid="pwa-dismiss-btn" className="text-[#57534E] hover:text-[#1C1917]">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
